import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * Shuttle carrier name + DOT number for one stop. Mirrors the
 * `origin_shuttle_carrier_*` / `destination_shuttle_carrier_*` columns that
 * customers already populate through the public `/orders` API.
 */
export function ShuttleCarrierFields({
  idPrefix,
  name,
  dot,
  onNameChange,
  onDotChange,
  disabled,
}: {
  idPrefix: string;
  name: string;
  dot: string;
  onNameChange: (v: string) => void;
  onDotChange: (v: string) => void;
  disabled?: boolean;
}) {
  return (
    <div className="mt-4 grid gap-3 sm:grid-cols-2">
      <div>
        <Label htmlFor={`${idPrefix}-shuttle-name`}>Shuttle carrier</Label>
        <Input
          id={`${idPrefix}-shuttle-name`}
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="Carrier name"
          maxLength={120}
          disabled={disabled}
        />
      </div>
      <div>
        <Label htmlFor={`${idPrefix}-shuttle-dot`}>Shuttle carrier DOT #</Label>
        <Input
          id={`${idPrefix}-shuttle-dot`}
          value={dot}
          onChange={(e) => onDotChange(e.target.value)}
          placeholder="e.g., 1234567"
          maxLength={20}
          disabled={disabled}
        />
      </div>
    </div>
  );
}